<template>
    <div
        class="border rounded-lg border-stack-primary flex flex-col px-2 py-2 w-64"
    >
        <span class="h5 capitalize"> {{ input.format }}</span>
        <div class="flex justify-between">
            <span class="font-bold"> Fecha</span>
            <span> {{ input.date }}</span>
        </div>
        <div v-if="!hideHour" class="flex justify-between">
            <span class="font-bold"> Hora</span>
            <span> {{ input.hour }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "DateDeliveryViewer",
    props: {
        input: {
            default: () => ({}),
            type: Object,
            require: true
        },
        hideHour: {
            type: Boolean,
            default: false
        }
    }
};
</script>
